/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import {
  Tooltip as MUITooltipBase,
  TooltipProps as MUITooltipProps,
} from '@material-ui/core';

interface TooltipBaseProps extends MUITooltipProps {
  disabled?: boolean;
}

export default function TooltipBase(props: TooltipBaseProps) {
  const { children, classes, disabled, title, ...restProps } = props;

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <>
      {children && title && (
        <MUITooltipBase
          {...restProps}
          classes={classes}
          interactive
          title={title}
        >
          {children}
        </MUITooltipBase>
      )}
    </>
  );
}
